import actionTypes from './../constants/actionTypes';

const initialState = {
    formJson: {},
    fetchingForms: {},
};
export const formsReducer = (state = initialState, action) => {
    try {
        const { type, payload, status, formKey = '' } = action;
        switch (type) {
            case actionTypes.FORMS.FETCHING_FORM: {
                return {
                    ...state,
                    fetchingForms: {
                        ...state.fetchingForms,
                        [`${formKey}`]: true
                    }
                }
            }
            case actionTypes.FORMS.FORM_FETCHED: {
                return {
                    ...state,
                    formJson: {
                        ...state.formJson,
                        [`${formKey}`]: payload
                    }
                }
            }
        }
        return state;
    } catch (error) {
        return state;
    }
}
export default formsReducer;
